/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {CheckCircleIcon, PencilSquareIcon, PlusIcon, QrCodeIcon, XCircleIcon, XMarkIcon} from '@heroicons/react/24/outline'
import {getVenueSession} from "../../requests/AppSession";
import {useNavigate} from "react-router-dom";
import LoginError from "../login/LoginError";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "../header/Header";
import sound from "./sound/tip.mp3"
import soundError from "./sound/error.mp3"
import Footer from "../footer/Footer";
import {useAuth0} from "@auth0/auth0-react";
import {addDancerAppToVenue, createDancerAppForVenue} from "../requests/AppRequestVenue";
import VTCheckInDancerQRReader from "./VTCheckInDancerQRReader";

export default function VTCheckInDancer() {
    let navigate = useNavigate();

    const {isLoading, getAccessTokenSilently} = useAuth0();

    const [open, setOpen] = useState(false);
    const [openAddNew, setOpenAddNew] = useState(false);

    const [show, setShow] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(null);
    const [showSuccessSubMessage, setShowSuccessSubMessage] = useState(null);

    const [showError, setShowError] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(null);

    const [isQRReader, setIsQRReader] = useState(false);
    const [isTypeIn, setIsTypeIn] = useState(false);

    const [showQRReader, setShowQRReader] = useState(false);

    const [selectedSize, setSelectedSize] = useState(null);
    const [userCode, setUserCode] = useState(null);
    const [adminCode, setAdminCode] = useState(null);
    const [newDancerName, setNewDancerName] = useState(null);
    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [adminCodeFeatureFlag, setAdminCodeFeatureFlag] = React.useState(null);

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.id !== "null") {
                setVenueId(venueSession.venueId);
                setVenueName(venueSession.venueName);
                setIsQRReader(venueSession.venueScanCustomerCodePaymentsFeatureFlag);
                setIsTypeIn(venueSession.venueInputCustomerCodePaymentsFeatureFlag);
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })
        return function cleanup() {

        };
    }, []);

    const submitSuccess = async responseJson => {
        setIsSubmitting(false);
        console.log(responseJson);
        if (
            responseJson &&
            responseJson.id
        ) {
            // setAdminCode(null);
            setShow(true);
            setShowSuccessMessage(responseJson.name + " successfully checked in!");
            setShowSuccessSubMessage("");
            setUserCode(null);
            setNewDancerName(null);
            setSelectedSize(null);
            setOpen(false);
            setOpenAddNew(false);
            setShowQRReader(false);
            setTimeout(() => {
                setShow(false);
            }, 10000);
            await new Audio(sound).play();
        } else {
            setShow(false);
            setShowQRReader(false);
            setErrorMessage("There was a problem checking in Dancer. Please verify Dancer Code is correct.");
            setShowError(true);
            setShowErrorMessage("Failed to check in Dancer!");
            setTimeout(() => {
                setShowError(false);
            }, 10000);
            await new Audio(soundError).play();
        }
    };

    const submitError = forceLogout => {
        setShow(false);
        setShowQRReader(false);
        setIsSubmitting(false);
        setErrorMessage("There was a problem checking in Dancer. Please verify Dancer Code is correct.");
        setShowError(true);
        setShowErrorMessage("Failed to check in Dancer!");
        setTimeout(() => {
            setShowError(false);
        }, 10000);
        new Audio(soundError).play();
    };

    const submitVT = (selectedSize, dancerString) => {
        const dancer = JSON.parse(dancerString);
        if (!dancer.dancerCode || dancer.dancerCode.trim() === "") {
            setErrorMessage("There was a problem checking in Dancer. Please verify Dancer Code is correct.");
            setShowError(true);
            setShowErrorMessage("Failed to check in Dancer!");
            setTimeout(() => {
                setShowError(false);
            }, 10000);
            new Audio(soundError).play();
            return;
        }
        setErrorMessage(null);
        setIsSubmitting(true);
        addDancerAppToVenue(venueId, dancer.dancerCode, submitSuccess, submitError, getAccessTokenSilently);
    };

    const createSuccess = async responseJson => {
        setIsSubmitting(false);
        if (
            responseJson &&
            responseJson.id
        ) {
            setShow(true);
            setShowSuccessMessage(responseJson.name + " successfully created and checked in!");
            let subMessage = "Dancer Code: " + responseJson.dancerCode;
            if (responseJson.payoutPinNumber !== null && responseJson.payoutPinNumber !== undefined) {
                subMessage += " | Payout Pin: " + responseJson.payoutPinNumber;
            }
            setShowSuccessSubMessage(subMessage);
            setNewDancerName(null);
            setSelectedSize(null);
            setOpen(false);
            setOpenAddNew(false);
            setShowQRReader(false);
            setTimeout(() => {
                setShow(false);
            }, 30000);
            await new Audio(sound).play();
        } else {
            setShow(false);
            setShowQRReader(false);
            setErrorMessage("There was a problem creating the Dancer. Please try again.");
            setShowError(true);
            setShowErrorMessage("Failed to create Dancer!");
            setTimeout(() => {
                setShowError(false);
            }, 10000);
            await new Audio(soundError).play();
        }
    };

    const createError = forceLogout => {
        setShow(false);
        setShowQRReader(false);
        setIsSubmitting(false);
        setErrorMessage("There was a problem creating the Dancer. Please try again.");
        setShowError(true);
        setShowErrorMessage("Failed to create Dancer!");
        setTimeout(() => {
            setShowError(false);
        }, 10000);
        new Audio(soundError).play();
    };

    const submitCreateDancer = () => {
        if (!newDancerName || newDancerName.trim() === "") {
            setErrorMessage("Please enter the Dancer's name.");
            return;
        }
        setErrorMessage(null);
        setIsSubmitting(true);
        createDancerAppForVenue(venueId, newDancerName.trim(), createSuccess, createError, getAccessTokenSilently);
    };

    return (
        <>
            {
                showQRReader ?
                    <VTCheckInDancerQRReader setIsQRReader={setIsQRReader} submitVT={submitVT}
                                             selectedSize={selectedSize}
                                             setShowQRReader={setShowQRReader}/> :
                    <>
                        <Header headerType="AdminDancerCheckinOnly"/>
                        <div className="bg-white dark:bg-gray-900">

                            <div className="bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
                                <div className="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8">
                                    <div className="flex flex-col items-center">
                                        <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-100 text-center sm:text-5xl">Dancer
                                            <span
                                                className="text-pink-400">CheckIn</span></h1>

                                        <div className="mt-10 w-full max-w-xs space-y-3">
                                            {isQRReader && <button
                                                className="flex w-full items-center justify-center gap-2 rounded-lg bg-pink-600 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-pink-500 active:bg-pink-700"
                                                onClick={(event) => {
                                                    setShowQRReader(true);
                                                }}
                                            >
                                                <QrCodeIcon className="h-5 w-5" aria-hidden="true"/>
                                                Scan Dancer Code
                                            </button>}
                                            {isTypeIn && <button
                                                className="flex w-full items-center justify-center gap-2 rounded-lg bg-pink-600 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-pink-500 active:bg-pink-700"
                                                onClick={(event) => {
                                                    setOpen(true);
                                                }}
                                            >
                                                <PencilSquareIcon className="h-5 w-5" aria-hidden="true"/>
                                                Enter Dancer Code
                                            </button>}

                                            {/* Secondary action: create a temporary dancer for tonight only. */}
                                            <div className="flex items-center gap-3 pt-2">
                                                <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700"/>
                                                <span className="text-xs font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">or</span>
                                                <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700"/>
                                            </div>
                                            <button
                                                className="flex w-full items-center justify-center gap-2 rounded-lg bg-white dark:bg-gray-800 py-3 text-sm font-semibold text-pink-700 ring-1 ring-inset ring-pink-300 transition hover:bg-pink-50 active:bg-pink-100"
                                                onClick={(event) => {
                                                    setErrorMessage(null);
                                                    setNewDancerName(null);
                                                    setOpenAddNew(true);
                                                }}
                                            >
                                                <PlusIcon className="h-5 w-5" aria-hidden="true"/>
                                                Add Only For Tonight
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer/>
                    </>
            }

            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 shadow-xl">
                                            <div className="h-0 flex-1 overflow-y-auto">
                                                <div className="bg-pink-700 px-4 py-6 sm:px-6">
                                                    <div className="flex items-center justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-white">
                                                            Dancer Check In
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="rounded-md bg-pink-700 text-pink-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    setSelectedSize(null);
                                                                    // setAdminCode(null);
                                                                    setUserCode(null);
                                                                    setOpen(false);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex flex-1 flex-col justify-between">
                                                    <div className="divide-y divide-gray-200 dark:divide-gray-700 px-4 sm:px-6">
                                                        <div className="space-y-6 pb-5 pt-6">
                                                            {errorMessage && <LoginError errorMessage={errorMessage}/>}
                                                            <div>
                                                                <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    Dancer Code
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        type="text"
                                                                        name="userCode"
                                                                        value={userCode ?? ""}
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        onChange={(event) => {
                                                                            let uc = event.target.value;
                                                                            if (uc) {
                                                                                uc = uc.toUpperCase();
                                                                            }
                                                                            setUserCode(uc);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {adminCodeFeatureFlag && <div>
                                                                <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    Admin Code
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        type="text"
                                                                        name="adminCode"
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        onChange={(event) => {
                                                                            setAdminCode(event.target.value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                    onClick={() => {
                                                        setSelectedSize(null);
                                                        setUserCode(null);
                                                        setOpen(false)
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    disabled={isSubmitting}
                                                    className="ml-4 inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                                    onClick={() => {
                                                        if (!userCode || userCode.trim() === "") {
                                                            setErrorMessage("There was a problem assigning the VT to the User. Please verify User Code is correct.");
                                                            return;
                                                        }

                                                        const dancerObject = {
                                                            "dancerCode" : userCode
                                                        };

                                                        submitVT(null, JSON.stringify(dancerObject));
                                                    }}
                                                >
                                                    Check In Dancer {isSubmitting &&
                                                    <CircularProgress color="inherit" size={20}/>}
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            <Transition.Root show={openAddNew} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenAddNew}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 shadow-xl">
                                            <div className="h-0 flex-1 overflow-y-auto">
                                                <div className="bg-pink-700 px-4 py-6 sm:px-6">
                                                    <div className="flex items-center justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-white">
                                                            Add New Dancer
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="rounded-md bg-pink-700 text-pink-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    setNewDancerName(null);
                                                                    setErrorMessage(null);
                                                                    setOpenAddNew(false);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex flex-1 flex-col justify-between">
                                                    <div className="divide-y divide-gray-200 dark:divide-gray-700 px-4 sm:px-6">
                                                        <div className="space-y-6 pb-5 pt-6">
                                                            {errorMessage && <LoginError errorMessage={errorMessage}/>}
                                                            <div>
                                                                <label
                                                                    htmlFor="new-dancer-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    Dancer Name
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        id="new-dancer-name"
                                                                        type="text"
                                                                        name="newDancerName"
                                                                        value={newDancerName ?? ""}
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        onChange={(event) => {
                                                                            setNewDancerName(event.target.value);
                                                                        }}
                                                                    />
                                                                </div>
                                                                <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                                                                    A dancer code will be generated automatically and
                                                                    shown after the dancer is created.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                    onClick={() => {
                                                        setNewDancerName(null);
                                                        setErrorMessage(null);
                                                        setOpenAddNew(false);
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    disabled={isSubmitting}
                                                    className="ml-4 inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                                    onClick={() => {
                                                        submitCreateDancer();
                                                    }}
                                                >
                                                    Create & Check In {isSubmitting &&
                                                    <CircularProgress color="inherit" size={20}/>}
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={show}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div
                            className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <CheckCircleIcon className="h-6 w-6 text-green-600" aria-hidden="true"/>
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{showSuccessMessage}</p>
                                        {/*<p className="mt-1 text-sm text-gray-500">{addedVTAmount} VirtualTipz</p>*/}
                                        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{showSuccessSubMessage}</p>
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button
                                            type="button"
                                            className="inline-flex rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
                                            onClick={() => {
                                                setShow(false);
                                            }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>

            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={showError}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div
                            className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <XCircleIcon className="h-6 w-6 text-red-600" aria-hidden="true"/>
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{showErrorMessage}</p>
                                        {/*<p className="mt-1 text-sm text-gray-500">{selectedSize && selectedSize.virtualTips} VirtualTipz</p>*/}
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button
                                            type="button"
                                            className="inline-flex rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
                                            onClick={() => {
                                                setShowError(false);
                                                setErrorMessage(false);
                                            }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </>
    )
}
